import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import useLocales from "src/hooks/useLocales";
import * as Yup from "yup";

import useSendEmail from "../service/useSendEmail";

export type VerifyForm = {
	email: string;
};

export default function useEmailForm() {
	const { translate } = useLocales();

	const { onSubmit, loading } = useSendEmail();

	const schema = Yup.object().shape({
		email: Yup.string()
			.email(translate("demo.valid_email"))
			.required(translate("demo.email_required"))
	});

	const defaultValues = {
		email: ""
	};

	const methods = useForm<VerifyForm>({
		resolver: yupResolver(schema),
		defaultValues
	});

	const invalidEmail = () => {
		methods.setError("email", { message: translate("demo.email_confirmation_error_2") });
	};

	const handleSubmit = (data: VerifyForm) => {
		onSubmit(data, invalidEmail);
	};

	return {
		methods,
		onSubmit: methods.handleSubmit(handleSubmit),
		loading
	};
}
